
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best of North Goa with an exciting sightseeing package by bus. Visit stunning beaches, historic landmarks, and more in a convenient and affordable way.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover North Goa with a bus sightseeing package. From beautiful beaches to historic sites, enjoy a convenient tour that showcases the best of this vibrant region.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Explore North Goa’s top attractions with a convenient bus sightseeing package. Visit stunning beaches and historic spots for a memorable experience.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'north goa sightseeing package by bus, north goa sightseeing package by ac bus, north goa sightseeing package by car, north goa sightseeing package by car price, north goa sightseeing package, north goa sightseeing list, north goa sightseeing full dau tour, north goa sightseeing places',
        },
       
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Destinations",
      text: "Discover breathtaking views and hidden gems with the best sightseeing spots in Goa!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're an adventure lover or prefer a relaxed tour, there's something for everyone!",
    },
    {
      title: "Local Guides",
      text: "Our experienced guides will take you to the top attractions and share fascinating insights.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect sightseeing tour effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'North Goa Sightseeing - North Goa Sightseeing Package by Bus',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/north-goa-sightseeing-package-by-bus`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/north-goa-sightseeing-package-by-bus`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/north-goa-sightseeing-package-by-bus`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "North Goa Sightseeing Package by Bus - Book @ ₹399 Flat 33% Off",
  "description": "Experience the best sightseeing in North Goa by Bus, where stunning landscapes, vibrant culture, and iconic landmarks come together for an unforgettable journey filled with picturesque moments.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "399",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/north-goa-sightseeing-package-by-bus",
        "url": "https://www.goa.app/north-goa-sightseeing-package-by-bus",
        "name": "North Goa Sightseeing Package by Bus",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-02-28T07%3A22%3A03.721Zsnow-park-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=ZN1gdQRK4lunhHbMGaGRi0yRXaiR1wD5WkMFRpyWXhtNqkVfQjMI0Z7ZMy9JaSRzIjbiT9mk8Tf1t3oF7oBRVssGL%2BqRFFlc%2BS5YM%2FP9W7B1sa4pQ7ykEapzYYM6GHKwh5WytoNmGasdSFDsD5Um4WXczQ03B8pME8Dyg%2FrNqZC7oVU2iREuftMsD7HV0dbR843WiGasvPhE%2BuAKTaI7dhsZAvBsBToDCvmTXHZgI8TUmRrn3KnauNoNFJH35FTyO7i4ZkPh9b3fj68t5rhGPyk0LiMyxiH9%2BVnJq7nTQ85XMblgoRqm83p64MndTJ0jY8ssfiw%2FXqJkZbVIONjnWg%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "North Goa sightseeing Package by Bus offers breathtaking views of stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for travelers looking to explore beautiful sunsets, historic sites like Aguada Fort, and lush greenery, creating unforgettable memories along the way.",
        "breadcrumb": {
            "@id": "https://www.goa.app/north-goa-sightseeing-package-by-bus/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/north-goa-sightseeing-package-by-bus"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What are the key attractions covered in the North Goa sightseeing package by bus?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The North Goa sightseeing package by bus typically covers major spots like Calangute Beach, Baga Beach, Aguada Fort, and Sinquerim Beach."
      }
    },
    {
      "@type": "Question",
      "name": "How much does a North Goa sightseeing bus tour cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The cost of a North Goa sightseeing package by bus usually starts from ₹399, depending on the package and services included."
      }
    },
    {
      "@type": "Question",
      "name": "How long does a North Goa sightseeing bus tour last?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most North Goa sightseeing bus tours last for a full day, typically around 8 to 9 hours, covering several top attractions."
      }
    },
    {
      "@type": "Question",
      "name": "Are the North Goa sightseeing bus tours guided?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, most bus tours include a guide who provides information about the various locations and their cultural significance."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time to book a North Goa sightseeing bus tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time to book a North Goa sightseeing bus tour is from November to February, when the weather is pleasant for outdoor activities."
      }
    },
    {
      "@type": "Question",
      "name": "Can I customize a North Goa sightseeing bus package?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Generally, bus tours follow a fixed itinerary, but some operators may offer semi-customizable packages with a few additional stops."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need to carry anything special for the bus tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It’s recommended to carry water, sunscreen, comfortable footwear, and a hat, as the tour involves exploring outdoor attractions."
      }
    },
    {
      "@type": "Question",
      "name": "How do I book a North Goa sightseeing package by bus?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book a North Goa sightseeing package by bus through local tour operators or online platforms specializing in Goa tours."
      }
    },
    {
      "@type": "Question",
      "name": "Is transportation included in the sightseeing package?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, the package includes transportation by bus to all the designated sightseeing locations in North Goa."
      }
    },
    {
      "@type": "Question",
      "name": "Can children join the North Goa sightseeing bus tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, North Goa sightseeing bus tours are family-friendly, and children can join, but some tours may offer discounted rates for kids."
      }
    }
        ]
      }
    ]
  };
},


};



  